import script from "./VoucherItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherItem.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherItem.vue?vue&type=style&index=0&id=3bab69e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bab69e8"]])

export default __exports__